/* ==========================================================================
   Black Mango — Product Tilt
   3D tilt effect on elements with [data-tilt].
   Vanilla JS, no dependencies. Respects prefers-reduced-motion.
   ========================================================================== */

(function () {
  'use strict';

  function init() {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;
    if ('ontouchstart' in window) return;

    const elements = document.querySelectorAll('[data-tilt]');
    if (elements.length === 0) return;

    const MAX_DEG = 8;

    for (const el of elements) {
      let rafId = null;

      /* Ensure the element can receive the shine overlay */
      el.style.position = el.style.position || 'relative';
      el.style.overflow = 'hidden';
      el.style.transition = 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)';
      el.style.willChange = 'transform';

      /* Create shine overlay */
      const shine = document.createElement('div');
      shine.style.cssText =
        'position:absolute;inset:0;pointer-events:none;z-index:1;' +
        'background:radial-gradient(circle at 50% 50%, rgba(200,148,62,0.15), transparent 60%);' +
        'opacity:0;transition:opacity 0.3s ease;';
      el.appendChild(shine);

      el.addEventListener('mousemove', function (e) {
        if (rafId) cancelAnimationFrame(rafId);

        rafId = requestAnimationFrame(function () {
          const rect = el.getBoundingClientRect();
          const x = (e.clientX - rect.left) / rect.width;
          const y = (e.clientY - rect.top) / rect.height;

          const rotateX = (0.5 - y) * MAX_DEG * 2;
          const rotateY = (x - 0.5) * MAX_DEG * 2;

          el.style.transform =
            'perspective(1000px) rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg)';

          /* Move shine to follow cursor */
          const shineX = (x * 100).toFixed(1);
          const shineY = (y * 100).toFixed(1);
          shine.style.background =
            'radial-gradient(circle at ' + shineX + '% ' + shineY + '%, rgba(200,148,62,0.18), transparent 60%)';
          shine.style.opacity = '1';

          rafId = null;
        });
      });

      el.addEventListener('mouseleave', function () {
        if (rafId) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
        el.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg)';
        shine.style.opacity = '0';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
